(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery.fn.InitializePage = function (option) {

    var defaults = {
        initialJsonData: null
    };

    var option = $.extend({}, defaults, option);

    var viewModelJS = JSON.parse(option.initialJsonData);
    var viewModel = ko.mapping.fromJS(viewModelJS);

    var pageContent = $(this);

    //Extending ViewModel
    viewModel.allResults = ko.observableArray();
    viewModel.visibleResults = ko.observableArray();
    viewModel.showMoreButton = ko.observable(true);

    if (viewModel.relatedTopics().length > 0) {
        ko.mapping.fromJS(viewModel.relatedTopics, {}, viewModel.allResults);

        var initCount = viewModel.initCount();
        if (viewModel.allResults().length <= 3) {
            viewModel.showMoreButton(false);
            initCount = viewModel.allResults().length;
        }

        for (var i = 0; i < initCount; i++) {
            viewModel.visibleResults.push(viewModel.relatedTopics()[i]);
        }
    }

    viewModel.LoadMore = function () {

        var skip = viewModel.skip();
        if (viewModel.allResults().length <= viewModel.visibleResults().length + skip) {
            additionalResultsLength = viewModel.allResults().length;
            viewModel.showMoreButton(false);
        } else {
            additionalResultsLength = viewModel.visibleResults().length + skip;
            viewModel.showMoreButton(true);
        }

        for (var i = viewModel.visibleResults().length; i < additionalResultsLength; i++) {
            viewModel.visibleResults.push(viewModel.allResults()[i]);
        }
    };

    ////Sanitize Binding
    ko.cleanNode(pageContent.get(0));

    ////Apply Bindings
    ko.applyBindings(viewModel, pageContent.get(0));
};

},{}],2:[function(require,module,exports){
'use strict';

require('./features/relatedtopics-loadmore.js');
//var subscribeModal = require('./features/action-modal.js');

if (typeof initialJsonDataRelatedTopics != 'undefined' && initialJsonDataRelatedTopics != null) {
    $('.trending-topics').InitializePage({
        initialJsonData: initialJsonDataRelatedTopics
    });
}

//todo refactor so accordion is generic and can work with accordion on about pages
$(document).ready(function () {

    var $accordionList,
        $accordionList = $('.services-accordion');

    if ($accordionList.length) {
        $accordionList.find('.list__link--accordion-toggle').on('click', function (e) {
            var _self = $(this);
            _self.next('.button--accordion-toggle').trigger('click');
        });
        $accordionList.find('.button--accordion-toggle').on('click', function () {
            var _self = $(this);
            _self.toggleClass('expanded');

            var $parent = _self.closest('.list__item--services');
            $parent.toggleClass('expanded');

            $parent.next().slideToggle();
        });

        $('.button-expand-all').on('click', function () {
            var _self = $(this);

            _self.hide();
            $accordionList = _self.parent('.services-accordion');

            if (_self.hasClass('expand')) {
                $accordionList.find('.services__content').slideDown();
                $accordionList.find('.list__item--services').addClass('expanded');
                $accordionList.find('.button--accordion-toggle').addClass('expanded');
                _self.next().show(); //show collapse btn
            } else {
                $accordionList.find('.services__content').slideUp();
                $accordionList.find('.list__item--services').removeClass('expanded');
                $accordionList.find('.button--accordion-toggle').removeClass('expanded');
                _self.prev().show(); //show expand btn
            }
        });
    }
});

//subscribeModal();

},{"./features/relatedtopics-loadmore.js":1}]},{},[2]);
